import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/Button';
import { Card, CardHeader, CardContent } from '../components/ui/Card';
import { PasswordInput } from '../components/ui/PasswordInput';
import {
  StyledPageContainer,
  StyledFormContainer,
  StyledBrand,
  StyledForm,
  StyledInput,
  StyledError,
  StyledTitle,
  StyledSubtitle,
  StyledLink,
} from './LoginPage.styles';

export const LoginPage: React.FC = () => {
  const { t } = useTranslation();
  const { login, isAuthenticated, isLoading, error } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  if (isAuthenticated) {
    return <Navigate to='/dashboard' replace />;
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await login(formData.email, formData.password);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <StyledPageContainer>
      <StyledFormContainer>
        <StyledBrand>
          <span>claro</span>
          <span>Finance Friend Grow</span>
        </StyledBrand>
        <Card padding='lg'>
          <CardHeader>
            <StyledTitle>{t('auth.login')}</StyledTitle>
            <StyledSubtitle>Welcome back to Finance Friend Grow</StyledSubtitle>
          </CardHeader>
          <CardContent>
            <StyledForm onSubmit={handleSubmit}>
              <StyledInput
                type='email'
                name='email'
                placeholder={t('auth.email')}
                value={formData.email}
                onChange={handleChange}
                required
              />
              <PasswordInput
                name='password'
                placeholder={t('auth.password')}
                value={formData.password}
                onChange={handleChange}
                required
                hasError={!!error}
              />
              {error && <StyledError>{error}</StyledError>}
              <Button type='submit' fullWidth isLoading={isLoading}>
                {t('auth.login')}
              </Button>
            </StyledForm>
            <StyledLink to='/register'>Don't have an account? {t('auth.register')}</StyledLink>
          </CardContent>
        </Card>
        <a
          href='https://bitonstudio.com'
          target='_blank'
          rel='noopener noreferrer'
          style={{ display: 'block', marginTop: '1.5rem', textAlign: 'center', fontSize: '0.75rem', opacity: 0.6 }}
        >
          Built by DB Studio
        </a>
      </StyledFormContainer>
    </StyledPageContainer>
  );
};
